import { motion } from "framer-motion";
import { Heart, Trophy } from "lucide-react";
import Reveal from "./Reveal";

export default function About() {
  return (
    <section id="about" className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        {/* Photo placeholder */}
        <Reveal>
          <div className="relative">
            <div className="wc-blob" style={{ background: "#FF4D6D", width: 300, height: 300, top: -30, left: -40, opacity: 0.3 }} />
            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              className="relative z-10 mx-auto aspect-[4/5] w-full max-w-sm overflow-hidden rounded-[2rem] border-4 border-white shadow-[0_30px_60px_-20px_rgba(255,77,109,0.4)]"
              data-testid="zoey-photo"
            >
              <img src="/assets/zoey.png" alt="Zoey Christian, founder of ZoJu Juices" className="h-full w-full object-cover" />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/45 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl bg-white/80 px-4 py-3 backdrop-blur-md">
                <div>
                  <p className="font-script text-3xl leading-none text-ink">Zoey</p>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/50">Founder · Age 11</p>
                </div>
                <Heart className="h-6 w-6 text-watermelon" fill="#FF4D6D" />
              </div>
            </motion.div>
          </div>
        </Reveal>

        {/* Story */}
        <div>
          <Reveal>
            <p className="font-script text-3xl text-leaf">03 — the founder</p>
            <h2 className="mt-1 font-display text-4xl sm:text-6xl font-extrabold uppercase tracking-tighter text-ink">
              Meet Zoey
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink/70">
              <p>
                Zoey Christian is an 11-year-old entrepreneur and aspiring track runner from
                sunny Orlando, Florida. On the track she learned that what you put in your body
                is what powers you forward.
              </p>
              <p>
                So she started <b className="text-watermelon">ZoJu Juices</b> — all-natural, freshly
                made juice to fuel young athletes the natural way. No preservatives, no artificial
                colors. Just real fruit, sea moss, and a whole lot of heart.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="inline-flex items-center gap-2 rounded-full bg-cream px-5 py-3 text-sm font-semibold text-ink">
                <Trophy className="h-5 w-5 text-leaf" /> Aspiring track runner
              </div>
              <div className="inline-flex items-center gap-2 rounded-full bg-cream px-5 py-3 text-sm font-semibold text-ink">
                <Heart className="h-5 w-5 text-watermelon" /> Made with love in Orlando
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
